export default __webpack_public_path__ + "static/media/icon-applied.61497b72.svg";